import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

type Props = HTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
  variant?: "default" | "lime" | "removable" | "locked";
  icon?: ReactNode;
  count?: number;
};

const variantClass = {
  default:
    "border-2 border-ink/15 text-ink hover:border-ink",
  lime:
    "bg-lime text-[var(--fg-on-accent)] border-2 border-lime",
  removable:
    "bg-ink text-white border-2 border-ink",
  locked:
    "border-2 border-ink/10 text-ink-40 cursor-not-allowed",
};

export function Chip({ active, variant = "default", icon, count, className, children, ...rest }: Props) {
  const v = active && variant === "default" ? "lime" : variant;
  return (
    <button
      type="button"
      disabled={v === "locked"}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-pill h-8 px-3 text-[13px] font-display font-semibold whitespace-nowrap transition-colors",
        variantClass[v],
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
      {count !== undefined && (
        <span className="ml-1 text-[11px] opacity-60 font-mono">{count}</span>
      )}
    </button>
  );
}
